import {
  Row,
  Col,
  Typography,
  Button,
  Space,
  Tag,
  message,
  Card,
  Select,
  Checkbox,
  Input,
  Divider,
} from "antd";

import {
  FileTextOutlined,
  SaveOutlined,
  DownloadOutlined,
  MailOutlined,
  CompassOutlined,
} from "@ant-design/icons";

const { Title, Text } = Typography;

const QuoteHeader = ({
  days = [],

  pricing = {},

  vehicleOptions = [],

 setVehicleOptions,

  selectedOffer,
  remainingTime,
  isExpired,

  globalTransportConfig,

  setGlobalTransportConfig,

  onSaveDraft,

  onGeneratePdf,

  loading = false,

lead = {},

quotationSettings,

setQuotationSettings,

onCopyEmailQuote,

onOpenActivitySearch,

mode = "edit",

}) => {

const isViewMode =
  mode === "view";

const isDuplicateMode =
  mode === "duplicate";

const isUseMode =
  mode === "use";

const isEditMode =
  mode === "edit";

  /* =========================================
     SAVE DRAFT
  ========================================= */

  const handleSaveDraft = async () => {

    try {

      if (!onSaveDraft) {

        message.error(
          "Save draft handler missing"
        );

        return;
      }

      await onSaveDraft();

      message.success(
        "Quotation draft saved"
      );

    } catch (error) {

      console.error(
        "Save draft failed:",
        error
      );

      message.error(
        error?.message ||

        "Failed to save quotation"
      );
    }
  };

  /* =========================================
     GENERATE PDF
  ========================================= */

  const handleGeneratePdf = async () => {

    try {

      if (!onGeneratePdf) {

        message.error(
          "PDF handler missing"
        );

        return;
      }

      await onGeneratePdf();

    } catch (error) {

      console.error(
        "PDF generation failed:",
        error
      );

      message.error(
        error?.message ||

        "Failed to generate PDF"
      );
    }
  };

  /* =========================================
     NORMALIZED LEAD DATA
  ========================================= */

  const destinationName =

    lead?.destination?.name ||

    lead?.destination?.city ||

    lead?.destination?.title ||

    (
      typeof lead?.destination ===
      "string"

        ? lead.destination

        : "-"
    );

const travelDate =

  lead?.travelDate

    ? new Date(
        lead.travelDate
      ).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })

    : "-";

  const adults =

    lead?.pax?.adults ||

    lead?.travelers?.adults ||

    lead?.numberOfTravelers
      ?.adults ||

    lead?.numberOfAdults ||

    1;

  const children =

    lead?.pax?.children ||

    lead?.travelers?.children ||

    lead?.numberOfTravelers
      ?.children ||

    lead?.numberOfChildren ||

    0;

  const infants =

    lead?.pax?.infants ||

    lead?.travelers?.infants ||

    lead?.numberOfTravelers
      ?.infants ||

    lead?.numberOfInfants ||

    0;

const duration = (() => {

  if (lead?.duration) {

    return `${Math.max(
      0,
      lead.duration - 1
    )}N / ${lead.duration}D`;
  }

  if (days?.length > 0) {

    return `${Math.max(
      0,
      days.length - 1
    )}N / ${days.length}D`;
  }

  return "-";

})();

const formattedGrandTotal =
  Number(
    pricing?.total ||

    pricing?.grandTotal ||

    0
  ).toLocaleString("en-IN");

const formattedRemainingTime = (() => {
  const totalSeconds =
    Number(remainingTime);

  if (
    !Number.isFinite(totalSeconds) ||
    totalSeconds <= 0
  ) {
    return "00:00:00";
  }

  const hours =
    Math.floor(
      totalSeconds / 3600
    );

  const minutes =
    Math.floor(
      (totalSeconds % 3600) / 60
    );

  const seconds =
    totalSeconds % 60;

  return [
    String(hours).padStart(2, "0"),
    String(minutes).padStart(2, "0"),
    String(seconds).padStart(2, "0"),
  ].join(":");
})();


  return (

    <div
      style={{
        background: "#fff",

        padding: 24,

        borderRadius: 18,

        marginBottom: 24,

        border:
          "1px solid #e5e7eb",

        boxShadow:
          "0 4px 20px rgba(15,23,42,0.05)",
      }}
    >

      {/* =====================================
          LEAD SUMMARY
      ===================================== */}

{lead && (
  <div
    style={{
      marginBottom: 20,
      borderRadius: 16,
      background: "#f8fafc",
      border: "1px solid #e2e8f0",
      padding: 18,
      boxShadow: "inset 0 1px 2px rgba(0,0,0,0.02)",
    }}
  >
    <Row gutter={[20, 14]}>

      <Col xs={12} sm={8} md={6}>
        <div style={{ fontSize: 11, fontWeight: 700, textTransform: "uppercase", color: "#64748b", letterSpacing: "0.5px" }}>Customer</div>
        <div style={{ fontSize: 14, fontWeight: 700, color: "#0f172a", marginTop: 2 }}>{lead.customerName || "-"}</div>
      </Col>

      <Col xs={12} sm={8} md={6}>
        <div style={{ fontSize: 11, fontWeight: 700, textTransform: "uppercase", color: "#64748b", letterSpacing: "0.5px" }}>Phone</div>
        <div style={{ fontSize: 13, fontWeight: 600, color: "#334155", marginTop: 2 }}>{lead.phone || "-"}</div>
      </Col>

      <Col xs={12} sm={8} md={6}>
        <div style={{ fontSize: 11, fontWeight: 700, textTransform: "uppercase", color: "#64748b", letterSpacing: "0.5px" }}>Travel Date</div>
        <div style={{ fontSize: 13, fontWeight: 600, color: "#334155", marginTop: 2 }}>
          {lead.travelDate
            ? new Date(lead.travelDate).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })
            : "-"}
        </div>
      </Col>

      <Col xs={12} sm={8} md={6}>
        <div style={{ fontSize: 11, fontWeight: 700, textTransform: "uppercase", color: "#64748b", letterSpacing: "0.5px" }}>Return Date</div>
        <div style={{ fontSize: 13, fontWeight: 600, color: "#334155", marginTop: 2 }}>
          {lead.returnDate
            ? new Date(lead.returnDate).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })
            : "-"}
        </div>
      </Col>

      <Col xs={12} sm={8} md={6}>
        <div style={{ fontSize: 11, fontWeight: 700, textTransform: "uppercase", color: "#64748b", letterSpacing: "0.5px" }}>Duration</div>
        <div style={{ fontSize: 13, fontWeight: 700, color: "#4f46e5", marginTop: 2 }}>
          {lead.duration || "-"} Days
        </div>
      </Col>

      <Col xs={12} sm={8} md={6}>
        <div style={{ fontSize: 11, fontWeight: 700, textTransform: "uppercase", color: "#64748b", letterSpacing: "0.5px" }}>Pax Summary</div>
        <div style={{ fontSize: 13, fontWeight: 600, color: "#334155", marginTop: 2 }}>
          {(lead.pax?.adults || 0)} Adults, {(lead.pax?.children || 0)} Kids, {(lead.pax?.infants || 0)} Infants
        </div>
      </Col>

      <Col xs={12} sm={8} md={6}>
        <div style={{ fontSize: 11, fontWeight: 700, textTransform: "uppercase", color: "#64748b", letterSpacing: "0.5px" }}>Destination</div>
        <div style={{ fontSize: 13, fontWeight: 700, color: "#0f172a", marginTop: 2 }}>
          {lead.destination?.name || lead.destinationSnapshot || "-"}
        </div>
      </Col>

      <Col xs={12} sm={8} md={6}>
        <div style={{ fontSize: 11, fontWeight: 700, textTransform: "uppercase", color: "#64748b", letterSpacing: "0.5px" }}>Tags</div>
        <div style={{ marginTop: 2 }}>
          {(lead.tags || []).length > 0 ? (
            lead.tags.map((tag, idx) => (
              <span key={idx} style={{ display: "inline-block", fontSize: 11, background: "#e0e7ff", color: "#3730a3", fontWeight: 600, padding: "2px 8px", borderRadius: 999, marginRight: 4 }}>
                {tag}
              </span>
            ))
          ) : (
            <span style={{ fontSize: 13, color: "#94a3b8" }}>-</span>
          )}
        </div>
      </Col>

      {lead.notes && (
        <Col span={24}>
          <div style={{ fontSize: 11, fontWeight: 700, textTransform: "uppercase", color: "#64748b", letterSpacing: "0.5px" }}>Notes</div>
          <div style={{ fontSize: 12, color: "#475569", marginTop: 2 }}>{lead.notes}</div>
        </Col>
      )}

    </Row>
  </div>
)}

      <Card
        bordered={false}

        style={{
          marginBottom: 24,

          borderRadius: 18,

          background:
            "linear-gradient(135deg,#f8fbff 0%,#eef5ff 100%)",

          border:
            "1px solid #dbeafe",

          overflow: "hidden",
        }}
      >

        <Row
          gutter={[24, 24]}
          align="middle"
        >


          {/* VEHICLE */}

          <Col xs={24} md={8}>

            <Text type="secondary">
              Vehicle Type
            </Text>

<Select

  disabled={
    isExpired ||
    isViewMode
  }

  showSearch

  allowClear

  style={{
    width: "100%",
    marginTop: 6,
  }}

  value={
    globalTransportConfig?.vehicleType
  }

  options={[

    ...vehicleOptions.map(v => ({
      label: v,
      value: v,
    })),

    {
      label: "➕ Add Custom Vehicle",
      value: "__CUSTOM__",
    },

  ]}

  onChange={(value) => {

    if (value === "__CUSTOM__") {

      const vehicle = window.prompt(
        "Enter Vehicle Type"
      );

      if (!vehicle?.trim()) {
        return;
      }

      const updated = [
        ...vehicleOptions,
        vehicle.trim(),
      ];

      setVehicleOptions(
        [...new Set(updated)]
      );

      value = vehicle.trim();
    }

    setGlobalTransportConfig(
      (prev) => ({
        ...prev,
        vehicleType: value,
      })
    );

  }}
/>

          </Col>

          {/* SAME CAB */}

          <Col xs={24} md={12}>

            <div
              style={{
                marginTop: 24,
              }}
            >

              <Checkbox
  disabled={
    isExpired ||
    isViewMode
  }
                checked={
                  globalTransportConfig
                    ?.applySameCab
                }

                onChange={(e) => {

                  setGlobalTransportConfig(
                    (prev) => ({

                      ...prev,

                      applySameCab:
                        e.target.checked,
                    })
                  );
                }}
              >

                Same Cab For
                All Days

              </Checkbox>

            </div>

          </Col>

        </Row>

      </Card>

<Card
  bordered={false}
  style={{
    marginBottom: 24,
    borderRadius: 18,
    border: "1px solid #ede9fe",
    background:
      "linear-gradient(135deg,#ffffff 0%,#f5f3ff 100%)",
  }}
>

  <Row gutter={[20, 20]}>

    <Col xs={24} md={12}>

      <Text
        strong
        style={{
          color: "#6d28d9",
        }}
      >
        Proposal Title
      </Text>

      <Input
        disabled={
  isExpired ||
  isViewMode
}

        size="large"
        placeholder="Luxury Kashmir Escape"
        value={
          quotationSettings?.proposalTitle
        }

        onChange={(e) => {

          setQuotationSettings(
            (prev) => ({

              ...prev,

              proposalTitle:
                e.target.value,
            })
          );
        }}

        style={{
          marginTop: 8,
          borderRadius: 12,
        }}
      />

    </Col>

    <Col xs={24} md={12}>

      <Text
        strong
        style={{
          color: "#0f766e",
        }}
      >
        Proposal Subtitle
      </Text>

      <Input
        disabled={
        isExpired ||
        isViewMode
     }
        size="large"
        placeholder="Handcrafted Luxury Journey"
        value={
          quotationSettings?.proposalSubtitle
        }

        onChange={(e) => {

          setQuotationSettings(
            (prev) => ({

              ...prev,

              proposalSubtitle:
                e.target.value,
            })
          );
        }}

        style={{
          marginTop: 8,
          borderRadius: 12,
        }}
      />

    </Col>

  </Row>

</Card>

      {/* =====================================
          HEADER ACTIONS
      ===================================== */}

      <Row
        justify="space-between"
        align="middle"

        gutter={[16, 16]}
      >

        {/* LEFT */}

        <Col>

          <Space
            direction="vertical"

            size={2}
          >

            <Space align="center">

              <div
                style={{
                  width: 42,

                  height: 42,

                  borderRadius: 12,

                  background:
                    "#1677ff",

                  display: "flex",

                  alignItems:
                    "center",

                  justifyContent:
                    "center",
                }}
              >

                <FileTextOutlined
                  style={{
                    color: "#fff",

                    fontSize: 18,
                  }}
                />

              </div>

              <div>

                <Title
                  level={3}

                  style={{
                    margin: 0,
                  }}
                >
                  {
  isViewMode
    ? "Proposal Preview"

    : isDuplicateMode
    ? "Duplicate Proposal"

    : isUseMode
    ? "Reusable Proposal"

    : "Proposal Workspace"
}
                </Title>

                <Text type="secondary">

{
  isViewMode
    ? "Read Only Mode"

    : isDuplicateMode
    ? "Creating Proposal Copy"

    : isUseMode
    ? "Using Saved Proposal"

    : `${days.length} Days Itinerary`
}

                </Text>

              </div>

            </Space>

          </Space>

        </Col>

        {/* RIGHT */}

        <Col>

<Space
  size={12}
  wrap

            align="center"
          >

<Tag
  color={
    isViewMode
      ? "blue"

      : isDuplicateMode
      ? "purple"

      : isUseMode
      ? "gold"

      : "green"
  }

  style={{
    padding: "6px 12px",
    borderRadius: 999,
    fontWeight: 600,
  }}
>

  {
    isViewMode
      ? "Preview"

      : isDuplicateMode
      ? "Duplicate"

      : isUseMode
      ? "Reusable Template"

      : "Draft Proposal"
  }

</Tag>

            {selectedOffer && (

<Tag
  color="green"

  style={{
    padding:
      "6px 12px",

    borderRadius: 999,
  }}
>

  {
    selectedOffer?.title ||

    selectedOffer?.offerCode ||

    "Offer Applied"
  }

</Tag>

            )}

{selectedOffer && !isExpired && (

  <div
    style={{
      background:
        "linear-gradient(135deg,#fff7ed,#ffedd5)",

      border:
        "1px solid #fdba74",

      borderRadius: 14,

      padding:
        "10px 16px",

      width: "100%",
      maxWidth: 240,

    }}
  >

    <Text
      strong
      style={{
        color: "#c2410c",
        fontSize: 13,
      }}
    >
      Offer Locked Price
    </Text>

    <div
      style={{
        marginTop: 4,
        fontSize: 18,
        fontWeight: 800,
        color: "#7c2d12",
      }}
    >

      Expires in {formattedRemainingTime}

    </div>

    <div
      style={{
        marginTop: 4,
        color: "#9a3412",
        fontSize: 12,
      }}
    >

      Customer must confirm before timer ends

    </div>

  </div>

)}

{isExpired && (

  <Tag
    color="red"
    style={{
      padding:
        "8px 14px",

      borderRadius: 999,

      fontWeight: 700,
    }}
  >

    Offer Expired

  </Tag>

)}

            {/* GRAND TOTAL */}

            <div
              style={{
                background:
                  "#f8fafc",

                padding:
                  "12px 18px",

                borderRadius: 14,

                border:
                  "1px solid #e2e8f0",

                textAlign: "right",

                width: "100%",
                maxWidth: 180,
              }}
            >

              <Text type="secondary">
                Grand Total
              </Text>

              <br />

              <Title
                level={4}

                style={{
                  margin:
                    "4px 0 0",

                  color:
                    "#1677ff",
                }}
              >
                ₹ {formattedGrandTotal}
              </Title>

            </div>

            {/* SAVE */}

            <Button
            disabled={
  isExpired ||
  isViewMode
}

              icon={<SaveOutlined />}

              onClick={
                handleSaveDraft
              }

              loading={loading}

              size="large"

              style={{
                borderRadius: 10,
                background: "#fff",
                border: "1px solid #d1d5db",

              }}
            >
              Save Draft
            </Button>

{onOpenActivitySearch && (
  <Button
    icon={<CompassOutlined style={{ color: "#1677ff" }} />}
    onClick={onOpenActivitySearch}
    size="large"
    style={{
      borderRadius: 10,
      background: "#eef6ff",
      border: "1px solid #bfdbfe",
      color: "#1d4ed8",
      fontWeight: 600,
    }}
  >
    Activities Catalog
  </Button>
)}

<Button
disabled={
  isExpired ||
  isViewMode
}
  icon={<MailOutlined />}

  onClick={
    onCopyEmailQuote
  }

  size="large"

  style={{
    borderRadius: 10,
background: "#fff",
border:
  "1px solid #d1d5db",
  }}
>
  Copy Email Version
</Button>

            {/* PDF */}

<Button
  type="primary"

  icon={
    <DownloadOutlined />
  }

  onClick={
    handleGeneratePdf
  }

disabled={isExpired}

  loading={loading}

  size="large"

  style={{
    borderRadius: 10,

    fontWeight: 600,
  }}
>
  {
    isExpired
      ? "Offer Expired"
      : "Generate PDF"
  }
</Button>


          </Space>

        </Col>

      </Row>

    </div>
  );
};

export default QuoteHeader;
